import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter/wght.css';
import './ui/tokens.css';
import { bindQueryFocus, queryClient } from './api/queryClient';
import { lang, loadStrings } from './i18n/i18n';
import { initTelegram } from './telegram/webapp';
import { initTheme } from './theme/theme';
import { startSession } from './session/session';
import { syncFavorites } from './session/favorites';
import { initAnalytics } from './analytics/analytics';
import { installGlobalErrors } from './analytics/globalErrors';
import { App } from './App';

// сбои JS без обработчика → js_error — первым делом, чтобы поймать и ошибки запуска
installGlobalErrors();
document.documentElement.lang = lang;
initTelegram();
initTheme();
bindQueryFocus();
// вход — при каждом открытии (Р-10); события аналитики ждут его, чтобы уйти с user_id (не дольше 4 с)
const session = startSession().then(syncFavorites);
initAnalytics(session);

// словарь языка — до первого кадра (отдельный кусок; en — в основном)
void loadStrings().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
